import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            Search: 'Search',
            Back: 'Back',
            appName: 'Kanclerz',
        },
    },
    pl: {
        translation: {
            'File is larger than 10000000 bytes': 'Plik jest większy niż 10MB',
            'An error occurred while processing your request':
                'Wystąpił błąd podczas przetwarzania żądania',
            'Login to app': 'Logowanie',
            'Reset password': 'Resetuj hasło',
            'Activate account': 'Aktywacja konta',
            'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character':
                'Hasło musi mieć minimum 8 znaków i zawierać co najmniej: jedną małą literę, jedną dużą, jedną liczbę i jeden ze znaków @$!%*#?&-_.,:;()[]',
            'Register in app': 'Rejestracja',
            'Change password': 'Resetowanie hasła',
            'Broken link': 'Niepoprawny link',
            'Type email used while registration, we will send you link to page where you can change password':
                'Wpisz adres email w polu obok, wyślemy na niego link pod którym będzie można zresetować hasło',
            'Forgot password? Click': 'Zapomniałeś hasła? Kliknij',
            'Passwords do not match': 'Hasła nie pasują do siebie',
            'Back to login page': 'Wróć do strony logowania',
            'to reset it': 'aby je zresetować',
            'email is a required field': 'pole email jest wymagane',
            'name is a required field': 'pole imię jest wymagane',
            'surname is a required field': 'pole nazwisko jest wymagane',
            'pesel is a required field': 'pole PESEL jest wymagane',
            'Have account already? Login': 'Masz już konto? Zaloguj się',
            'login is a required field': 'pole login jest wymagane',
            'password is a required field': 'pole hasło jest wymagane',
            'password2 is a required field': 'pole powtórz hasło jest wymagane',
            'repeat password': 'powtórz hasło',
            'claims is a required field':
                'Zgoda na przetwarzanie danych jest obowiązkowa',
            Search: 'Szukaj',
            "Don't have account yet? Register":
                'Nie masz jeszcze konta? Zarejestruj się',
            here: 'tutaj',
            'first name': 'imię',
            surname: 'nazwisko',
            Login: 'Zaloguj',
            password: 'hasło',
            'Pass new password in fields on left. Passwords must match':
                'Wpisz nowe hasło w polach po lewej. Hasła muszą do siebie pasować',
            appName: 'Baza ekspertów',
            appFullName: 'Baza ekspertów',
            'Log in': 'Zaloguj',
            'Login form': 'Formularz logowania do wersji beta',
            'Contact book': 'Książka kontaktowa',
            'Please select positions from left list':
                'Wybierz ośrodek z listy po lewej',
            'show details': 'szczegóły',
            'phone number': 'tel.',
            'mobile phone number': 'tel. kom.',
            room: 'pokój',
            Users: 'Użytkownicy',
            Dashboard: 'Kokpit',
            Logout: 'Wyloguj',
            Edit: 'Edycja',
            Create: 'Stwórz',
            'Create document workflow': 'Utwórz obieg dokument',
            'Document type': 'Typ dokumentu',
            'Select document type...':
                'Wybierz typ dokumentu z rozwijanej listy...',
            "Document form will appear here after select it's type":
                'Po wybraniu typu dokumentu w tym miejscu pojawi się formularz',
            'Document form': 'Formularz dokumentu',
            Organizations: 'Organizacje',
            Compositions: 'Utwory',
            'Documents workflow': 'Obieg dokumentów',
            All: 'Wszystko',
            Incoming: 'Przychodzące',
            Outgoing: 'Wychodzące',
            Preview: 'Podgląd',
            Workflow: 'Obieg',
            Document: 'Dokument',
            'All workflows': 'Wszystkie',
            'My active workflows': 'Moje aktywne obiegi',
            'Document workflow preview': 'Podgląd',
            Close: 'Zamknij',
            'Edit document': 'Edytuj',
            Accept: 'Zaakceptuj',
            Reject: 'Odrzuć',
            'Sending a changed document will create a new workflow':
                'Wprowadzenie zmian do dokumentu spowoduje zamknięcie obecnego obiegu i stworzenie nowego',
            'My actions': 'Moje akcje',
            'Micro workflow': 'Stwórz mikro-obieg',
            'Add comment': 'Dodaj komentarz',
            'Add new request': 'Dodaj nowe żądanie',
            'Add new micro request': 'Dodaj nowe mikro-żądanie',
            'Document status changed to': 'Status dokumentu zmieniony na',
            accepted: 'zaakceptowany',
            rejected: 'odrzucony',
            closed: 'zamknięty',
            Save: 'Zapisz',
            Submit: 'Wyślij',
            'Comment for action': 'Komentarz do akcji',
            'Comment to workflow': 'Komentarz do obiegu',
            'Select employee': 'Wybierz pracownika',
            'Added new request for person': 'Dodano nową osobę',
            'Error occurred while adding new person. Message':
                'Wystąpił błąd podczas dodawnia nowej osoby. Wiadomość',
            'Error occurred while updating document. Try again later':
                'Wystąpił błąd podczas aktualizacji dokumentu. Spróbuj ponownie później',
            'Edit anyway': 'Edytuj mimo to',
            Add: 'Dodaj',
            'Select user': 'Wybierz użytkownika',
            Username: 'Nazwa użytkownika',
            Actions: 'Akcje',
            Delete: 'Usuń',
            FYI: 'Do wiadomości',
            'Related workflows': 'Powiązane obiegi',
            'Start typing to search': 'Zacznij pisać aby wyszukać',
            'You need to pick up user to add first':
                'Musisz wybrać użytkownika który ma zostać dodany',
            'Prev page': 'Poprzednia strona',
            'Next page': 'Kolejna strona',
            'No results': 'Brak rezultatów',
            of: 'z',
            'added to related workflows':
                'został dodany do powiązanych obiegów',
            'Error occurred while deleting related workflow. Try again':
                'Wystapił błąd poczas dodawania powiązanego obiegu. Spróbuj ponownie',
            'removed from related workflows':
                'został usunięty z powiązanych obiegów',
            'Added to FYI': 'został/a dodany/a do listy DW',
            'removed from FYI list': 'został/a usunięty/a z listy DW',
            'Error occurred while deleting FYI. Try again':
                'Wystąpił błąd podczas usuwania osoby z listy DW. Spróbuj ponownie',
            'You need to pick up workflow to add first':
                'Musisz wybrać obieg który ma zostać dodany',
            'Select workflow': 'Wybierz obieg',
            'Workflow name': 'Nazwa obiegu',
            'User is absent from': 'Nieobecny/a od',
            to: 'do',
            User: 'Użytkownik',
            'is absent from': 'jest nieobecny/a od',
            'User picked': 'Użytkownik wybrał',
            "as it's substitute while absence. By clicking button below you can assign substitute person":
                'na zastępstwo. Możesz przypisać zastępce poprzez kliknięcie w poniższy button',
            'Assign substitute': 'Przypisz',
            'added to micro request': 'dodany/a do mikro obiegu',
            'Error occurred while adding micro request. Try again':
                'Wystąpił błąd podczas dodawnia mikro-obiegu. Spróbuj ponownie',
            'Acceptor actions': 'Akcje',
            'Micro acceptor actions': 'Akcje',
            'Add micro workflow': 'Dodaj mikro obieg',
            'Select group acceptor': 'Wybierz akceptora grupy',
            Comment: 'Komentarz',
            'Select...': 'Wybierz',
            'Select action': 'Wybierz akcję',
            'Comment to action': 'Komentarz do akcji',
            'Close all micro requests': 'Zamknij wszytskie mikro-obiegi',
            'Auto-accept':
                'Zaakceptuj automatycznie po zamknieciu mikro-obiegów',
            'Return to substituted person': 'Zwróć do zastępowanej osoby',
            'Micro request': 'Mikro obieg',
            micro_accepted: 'zaakceptowany',
            micro_rejected: 'odrzucony',
            'Error occurred while updating micro request. Try again':
                'Wystąpił błąd podczas wykonywania akcji an mikro obiegu. Spróbuj ponownie',
            'New comment added to workflow': 'Dodano nowy komentarz do obiegu',
            'Error occurred while adding new comment. Try again':
                'Wystąpił błąd podczas dodawania nowego komentarz. Spróbuj ponownie',
            'Action succeed': 'Akcja wykonana poprawnie',
            'Error occurred. Try again': 'Wystąpił błąd. Spróbuj ponownie',
            'Accepting request without selected next acceptor closes the workflow. Are you sure?':
                'Akceptacja żądania bez wybranego kolejnego akceptora spowoduje jego zamknięcie. Jesteś pewien?',
            'If you want to close them and continue click "ok"':
                'Jeśli chcesz je zamknąć i wykonać akcję kliknij "Zamknij i kontynuuj"',
            'Close and continue': 'Zamknij i kontynuuj',
            Cancel: 'Anuluj',
            'Request includes unresolved micro-request':
                'Żądanie zawiera otwarte mikro-żądania',
            'Base data': 'Dane podstawowe',
            'Declaration for month': 'Deklaracja za miesiąc',
            'of year': 'roku',
            Position: 'Stanowisko',
            Employee: 'Pracownik',
            'Declaration date': 'Data złożenia deklaracji',
            'Click and start typing to select composition':
                'Kliknij i zacznij wpisywać aby wyszukać utwór po nazwie',
            'Percentage value of author participation':
                'Procent praw autorskich w miesiącu',
            Next: 'Dalej',
            Back: 'Wróć',
            'Copyright declaration': 'Miesięczne oświadczenie praw autorskich',
            Organisation: 'Organizacja',
            'Activity type': 'Typ aktywności',
            'sent with date': 'wysłana z datą',
            'Selected compositions': 'Wybrane utwory',
            Summary: 'Podsumowanie',
            'Secretary': 'Sekretarz',
            'Expert': 'Ekspert',
            'NewUser': 'Nowy użytkownik',
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: 'pl',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
